import { createAction } from 'redux-actions';

export const openMessagesDrawerAction = createAction('DRAWERS/OPEN_MESSAGES_DRAWER');

export const changeMessagesDrawerTypeAction = createAction('DRAWERS/CHANGE_MESSAGES_DRAWER_TYPE');
